import { arrayToMap } from "../util";
import { convertAsset } from "../cityConversion";

export const injects = ['city']

export const path = "/asset/list";

export const handler = (data, masterData) => {
  if (ENABLE_TEST_DATA) {
    data.assets.push({ name: 'assetIdなし' })
    data.assets.push({ assetId: 123456, name: 'prefなし'  })
    data.assets.push({ assetId: 123457, pref: 46, name: 'prefあり' });
    data.assets.push({ assetId: 123458, pref: 46, geo: {}, name: 'geoが空' });
    data.assets.push({ assetId: 123458, pref: 46, city: 'kagoshimashi', name: '正常なcityのみ' });
    data.assets.push({ assetId: 123459, assetType: "okunai", name: 'assetTypeのみ' });
    data.assets.push({ assetId: 123461, name: 'roomテスト', rooms: [
      { roomName: '空室(0)', vacant: 0, price: 10000, campaignPrice: 5000 },
      { roomName: '満室(1)', vacant: 1, price: 10000, campaignPrice: 5000 },
      { roomName: '空き予定(2)', vacant: 2, price: 10000, campaignPrice: 5000 },
      { roomName: 'お問い合わせ(3)', vacant: 3, price: 10000, campaignPrice: 5000 },
      { roomName: '利用不可(4)', vacant: 4, price: 10000, campaignPrice: 5000 },
      { roomName: '不正値(5)', vacant: 5, price: 10000, campaignPrice: 5000 },
    ] });
    data.assets.push({ assetId: 123462, name: '空のstation', stations: [
      {},
    ] });
    data.assets.push({ assetId: 123463, name: '不正なstation', stations: [
      { lineSlug: 'unknownline', station: 123456 },
    ] });
    data.assets.push({ assetId: 123464, name: '不正なcity', pref: 46, city: 'unknowncity'});
    data.assets.push({ assetId: 123465, name: 'cityのみ', city: 'unknowncity'});
  }

  data.assets.forEach(asset => {
    // もっとも近い駅からの距離(asset.min_station_distance)を計算する
    let min_station_distance = null;
    for (const stationInfo of asset.stations || []) {
      const distanceMethod = masterData.distanceMethod.byId[stationInfo.method];
      const station_distance = distanceMethod && stationInfo.distance * distanceMethod.ratio;
      if (
        min_station_distance == null ||
        station_distance < min_station_distance
      ) {
        min_station_distance = station_distance;
      }
    }
    asset.min_station_distance = min_station_distance;
    // 画像の形式を統一する
    asset.images = asset.images || [asset.image];
    // トランクハウス24を考慮した、assetTypeDigestを設定する
    if (asset.premium) {
      asset.assetIcon = "premium";
    } else {
      asset.assetIcon = asset.assetType;
    }
    if (asset.primaryCampaign !== undefined && asset.primaryCampaign !== null && asset.primaryCampaign !== "") {
      asset.assetIcon = asset.assetType + 'Campaign';
    }
    // 特定のcityを修正する
    convertAsset(asset);

    if (asset.pref && asset.city) {
      const city = masterData.city.byPrefAndSlug[asset.pref][asset.city];
      if (city && city.baseSlug) {
        asset.baseCity = city.baseSlug;
      }
    }
  });

  return {
    list: data.assets,
    byId: arrayToMap(data.assets, "assetId"),
  };
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/asset.js